module.exports = __webpack_public_path__ + "media/books/Books-Pile-After-99f30741.jpg";